module.exports = __webpack_public_path__ + "static/media/40.92c33886.png";